<template>
  <div class="user-card__container">
    <div class="user-card__profile-image-wrapper">
    <div :style="cardStyles" />
  </div>
  <p class="user-card__text">
    <span class="user-card__text-name">
      {{ name }}
    </span>
    <router-link v-if="showVMXEditProfile" class="user-card__edit-profile" :to="editProfileRoute">
      {{ $t('VMX.user_card_edit_profile') }}
      <font-awesome-icon :icon="['fas', 'external-link-alt']" />
    </router-link>
    <user-information v-if="!isMobile || mobileDisplayUserInformation" class="user-info-custom"></user-information>
  </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import config from '~/config/index'
import utils from '../utilities'
import UserInformation from './UserInformation.vue'

export default {
  components: {
    UserInformation
  },
  data() {
    return {
      isMobile: window.innerWidth <= 768 
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 768; 
    }
  },
  computed: {
    ...mapGetters({
      configForKey: 'config/configForKey',
      userData: 'user/user',
      instance: 'instancesState/getInstance',
      userTicket: 'userTicket/userTicket',
    }),
    
    mobileDisplayUserInformation() {
      const config = this.$store.getters['config/configForKey']('app_config')?.configV2?.defaultV2
      if (config && 'mobileDisplayUserInformation' in config) {
        return config.mobileDisplayUserInformation
      }
      return false
    },
    config() {
      return this.configForKey('app_config').config[0]
    },
    instanceConfig() {
      return config.getInstanceConfig(this.instance)
    },
    name() {
      return `${this.userData.Firstname} ${this.userData.Surname}`
    },
    userImage() {
      const customUserImage = this.configForKey('app_config').config[0].defaults.dummyProfileImage
      return this.userData.ProfilePicturePath ? this.userData.ProfilePicturePath : (customUserImage ? customUserImage : '/assets/img/placeholder.png')
    },
    cardStyles() {
      return `background-image: url(${this.userImage}); background-size:cover; height:90px; width:90px; display: block; border-radius: 90px; border: 1px solid var(--primary)`
    },
    editProfileUrl() {
      return this.instanceConfig.identityUrl ? `${this.instanceConfig.identityUrl}/Manage/Index` : `${this.instanceConfig.webformsUrl}/UserModules/Account/Profile.aspx?pRefreshLoginId=true`
    },
    showVMXEditProfile() {
      const defaults = this.configForKey('industry_config').config.defaults || this.configForKey('app_config').config[0].defaults
      if ('showVMXEditProfile' in defaults) {
        return defaults.showVMXEditProfile
      } return true
    },
    editProfileRoute() {
      const route = {
        name: 'UserFormPage',
      }
      return utils.appendDefaultParamsToRoute(route)
    },
    showAccessDenyInformation() {
      return 'showAccessDenyInformation' in this.config.defaults ? this.config.defaults.showAccessDenyInformation : true
    },
  },
  
}

</script>
<style>
.user-card__container {
  align-items: center;
}
.no-access-reasons-container {
  display: flex;
  flex-direction: column;
  gap: .5rem;
}
.no-access-reasons-container > p {
  margin: 0;
}
.user-information-flex {
  display: flex;
  flex-direction: column;
  gap: .25rem;
}
.section-toogle-container {
  background: #fff;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.user-card__show-information {
  font-size: 1rem;
  color: var(--primary);
}
.ticket-type__types-container {
  display: flex;
  gap: .5rem;
  flex-wrap: wrap;
}
.ticket-type__types {
  border: 1px solid var(--primary);
  border-radius: .25rem;
  font-size: 12px;
  display: flex;
  align-items: center;
  padding: .25rem .5rem;
}
</style>
